import React from 'react';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import translationsJson from 'data/translations.json';
import info from "data/info.json";
import './GenerationFilter.css';

const translations : Translations = translationsJson;

interface Props {
    onUpdate : Function;
    allowAll : boolean;
}

class GenerationFilter extends React.Component<Props, { currentValue: string }> {
    public static DefaultValue = "default";

    constructor(props: Props) {
        super(props);

        this.state = {
            currentValue: this.props.allowAll ? GenerationFilter.DefaultValue : info.generations[0].name
        }

		this.onChange = this.onChange.bind(this);
    }

    private onChange(event: SelectChangeEvent<unknown>, child: React.ReactNode) {
        this.setState({currentValue: String(event.target.value)});
        if(this.props.onUpdate) {
            this.props.onUpdate(String(event.target.value));
        }
    }

    render() {
        let optionList = info.generations.map((value) => {
            let endYear = value.range[1] === -1 ? translations.today[window.lang] : value.range[1];
            return (<MenuItem value={value.name} key={value.name}>{translations[value.name][window.lang] + " (" + value.range[0] + " - " + endYear + ")"}</MenuItem>);
        });

        if(this.props.allowAll)
            optionList = [<MenuItem value={GenerationFilter.DefaultValue} key="current-year">{translations.newestYear[window.lang]}</MenuItem>, ...optionList];

        return (
            <FormControl className="dropdown">
                <InputLabel id="dropdown-label">{translations.generation[window.lang]}</InputLabel>
                <Select labelId="dropdown-label" id="dropdown-select" onChange={this.onChange} value={this.state.currentValue} label={translations.generation[window.lang]}>
                    {optionList}
                </Select>
            </FormControl>
        );
    }
}

export default GenerationFilter;